import React from 'react';
import './Chapters.scss';

function Chapter3() {
  return (
    <>
      <section className="chapter">
        <p className="chapter__paragraph">
          Since 2017, Bluewhite has been developing an autonomous platform, "The Pathfinder,"
          capable of navigating and controlling a tractor or other piece of farm equipment just like
          a human driver. The platform includes hardware and software solutions powered by Intel, a
          suite of sensors, multiple cameras, global navigation satellite systems, and a
          communication stack that connects the newly autonomous vehicles to Bluewhite’s fleet and
          data management platform.
        </p>
        <p className="chapter__paragraph">
          “We’ve been working on different agricultural projects using autonomous air and ground
          vehicles for the last five years,” Ascher says. “Our first-hand experience in different
          locations—from Israel and Europe to North and South America—has shown us just how real
          those problems are.”
        </p>
        <p className="chapter__paragraph">
          After years of work, Bluewhite's autonomous solution was working seamlessly with a wide
          variety of farm equipment, especially those with permanent crops like orchards and
          vineyards, but they had no way to reliably transmit and process all the data their
          autonomous vehicles were now collecting. Poor connectivity in the field meant lower
          situational awareness for the robot operator and prevented growers from making decisions
          in real-time.
        </p>
        <p className="chapter__paragraph">
          "Connectivity and cellular coverage in rural areas are lacking in many parts of the
          world,” Ascher says, “including most farming areas in the United States. We are constantly
          looking for the best cutting-edge technologies we can bring to our customers. That’s why
          we wanted to leverage the 5G ecosystem.”
        </p>
        <p className="chapter__paragraph">
          In search of a solution, Bluewhite turned to Intel and the 5G Open Innovation Lab for
          support—forging a partnership with a company that understood their needs.
        </p>
      </section>
      <section className="chapter">
        <p className="chapter__title">Leveraging the Power of 5G Infrastructure</p>
        <p className="chapter__paragraph">
          The 5G Open Innovation Lab was founded in 2019 to bring together startups and industry
          leaders like Intel, Dell, Accenture, and Microsoft. “We set up the lab three years ago,”
          says Jim Brisimitzis, the Lab’s co-founder and CEO, “to build what we believe is the true
          potential of 5G and edge computing.” Brisimitzis emphasizes that the Lab is built, first
          and foremost, to facilitate collaboration between startups and the Lab’s partners.
        </p>
      </section>
    </>
  );
}

export default Chapter3;
